import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
            showPackage: false,
            showContractHolder: false,
            showContractNumber: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        propertySubjects: {
            showSimplifiedAddress: false,
        },
        showLinkedLoans: false,
    },
    history: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
